import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../../store/rootReducer';
import BottomSheet from '../../../components/BottomSheet';
import { closeSpotBottomSheet } from '../../../store/modaleSlice';
import { useSpotBottomSheetLayoutProps } from '../../../layouts/SpotBottomSheetLayout';

const SpotBottomSheet = () => {
  const appState = useSelector((state: RootState) => state.AppReducer);

  const dispatch = useDispatch();
  const SpotBottomSheetLayoutPropsBuilder = useSpotBottomSheetLayoutProps();
  const spotBottomSheetIsOpen = useSelector((state: RootState) => state.ModaleReducer.spotBottomSheetIsOpen);
  const spotBottomSheet = useSelector((state: RootState) => state.ModaleReducer.spotBottomSheet);

  return spotBottomSheet ? (
    <BottomSheet
      {...{
        isOpen: spotBottomSheetIsOpen,
        onDidDismiss: () => dispatch(closeSpotBottomSheet()),
      }}
      {...SpotBottomSheetLayoutPropsBuilder({
        spot: spotBottomSheet,
        actions: {
          playNow:
            spotBottomSheet.id && appState.isAdminMode
              ? () => {
                  console.log('IL FAUT CODER LE LANCEMENT DU SPOT ICI');
                  dispatch(closeSpotBottomSheet());
                }
              : undefined,
        },
      })}
    />
  ) : null;
};

export default SpotBottomSheet;
